module.exports = __webpack_public_path__ + "img/fake-user-11.a7203201.png";